module.exports = __webpack_public_path__ + "static/media/tutorial-05.022a8e9c.jpg";